import { AlertDescriptionMultiAnalysisProps } from "../../@types";
import AlertDescriptionSampleLink from "../AlertDescriptionSampleLink";

const AlertDescriptionStaticAnalysis = ({
  type,
  data,
  linksReloadDocument,
  onLinkClick
}: AlertDescriptionMultiAnalysisProps) => {
  const typeString = type.split("_").pop();
  return (
    <>
      Static Analysis{" "}
      <AlertDescriptionSampleLink
        data={data}
        linksReloadDocument={linksReloadDocument}
        onLinkClick={onLinkClick}
      />{" "}
      has {typeString}.
    </>
  );
};

export default AlertDescriptionStaticAnalysis;
